import moment from 'moment';

const tempItem = {
  cnt: 0,
  showInSimple: true,
  showInComplex: false,
  showInExpanded: true,
  showInCollapsed: true,
};

export const InsightTimeline = (
  insight,
  group,
  key,
  order,
  groupParentName,
) => {
  function getIcon(insight) {
    if (
      insight.action_status === 'C' ||
      insight.action_status === 'E' ||
      insight.action_status === 'A' ||
      insight.action_status === 'D' ||
      insight.action_status === 'S'
    ) {
      return 'shield';
    }
    if (insight.risk_status === 'h') {
      return 'redBell';
    }
    if (insight.risk_status === 'm') {
      return 'yellowBell';
    }
    if (insight.risk_status === 'l') {
      return 'greenBell';
    }
  }

  const Item = {
    ...tempItem,
    ...insight,
    type: getIcon(insight),
    insight_id: insight.id,
    id: key,
    group: group,
    start_time: moment(insight.when_created).valueOf(),
    end_time: insight.when_ended
      ? moment(insight.when_ended).valueOf()
      : moment(Date.now()).valueOf(),
    order: order,
    group_type: 'Insights',
    parent_name: 'Insights',
    group_parent_name: groupParentName,
  };

  return Item;
};
